// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/Modal.css */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4;
}

.modal-main {
  position: fixed;
  left: 281px;
  top: 100px;
  width: 33vw;
  height: 79vh;
  background: #EFF0F4;
  padding: 16px;
  padding-top: 24px;
  border-radius: 8px;
  text-align: center;
  z-index: 5;
}

.display-block {
  display: block;
}

.display-none {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/TabletsControlPage/Modals/addTabletModal.scss"],"names":[],"mappings":"AAAA,kBAAA;AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AACJ;;AAEE;EACE,eAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AACJ;;AAEE;EACE,cAAA;AACJ;;AAEE;EACE,aAAA;AACJ","sourcesContent":["/* src/Modal.css */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 4;\n  }\n  \n  .modal-main {\n    position: fixed;\n    left: 281px;\n    top: 100px;\n    width: 33vw;\n    height: 79vh;\n    background: #EFF0F4;\n    padding: 16px;\n    padding-top: 24px;\n    border-radius: 8px;\n    text-align: center;\n    z-index: 5;\n}\n  \n  .display-block {\n    display: block;\n  }\n  \n  .display-none {\n    display: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal`,
	"modal-main": `modal-main`,
	"display-block": `display-block`,
	"display-none": `display-none`
};
export default ___CSS_LOADER_EXPORT___;
